
    import * as React from 'react';

    const Search20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Search_20_svg__Icons/Search/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M8.5,2 C12.0898509,2 15,4.91014913 15,8.5 C15,10.1148687 14.4111063,11.592194 13.4363556,12.7289391 L18.0134785,17.3063718 L17.3063718,18.0134785 L12.7289391,13.4363556 C11.592194,14.4111063 10.1148687,15 8.5,15 C4.91014913,15 2,12.0898509 2,8.5 C2,4.91014913 4.91014913,2 8.5,2 Z M8.5,3 C5.46243388,3 3,5.46243388 3,8.5 C3,11.5375661 5.46243388,14 8.5,14 C11.5375661,14 14,11.5375661 14,8.5 C14,5.46243388 11.5375661,3 8.5,3 Z" id="Search_20_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Search20.displayName = 'Search20';

    export default Search20;
  